import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiChevronLeft, FiChevronRight, FiList } = FiIcons;

export default function LeadNavBar({ currentId }) {
  const navigate = useNavigate();
  const location = useLocation();

  const leadIds = location.state?.leadIds;
  const currentIndex = location.state?.currentIndex;

  if (!leadIds || !Array.isArray(leadIds) || currentIndex == null || currentIndex < 0) {
    return null;
  }

  const total = leadIds.length;
  const position = currentIndex + 1;
  const prevId = currentIndex > 0 ? leadIds[currentIndex - 1] : null;
  const nextId = currentIndex < total - 1 ? leadIds[currentIndex + 1] : null;

  const goTo = (id, newIndex) => {
    navigate(`/leads/${id}`, { state: { leadIds, currentIndex: newIndex } });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 flex justify-center pointer-events-none">
      {/* Offset for the sidebar on md+ */}
      <div className="w-full md:pl-64">
        <div className="flex justify-center pb-5 pointer-events-none">
          <div className="pointer-events-auto flex items-center gap-0 bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden divide-x divide-gray-200">
            {/* Previous */}
            <button
              onClick={() => prevId && goTo(prevId, currentIndex - 1)}
              disabled={!prevId}
              className="flex items-center gap-2 px-5 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <SafeIcon icon={FiChevronLeft} className="w-4 h-4" />
              Previous
            </button>

            {/* Position indicator */}
            <div className="flex items-center gap-2 px-6 py-3 text-sm font-semibold text-gray-900 bg-gray-50 select-none">
              <SafeIcon icon={FiList} className="w-3.5 h-3.5 text-gray-400" />
              <span className="text-primary">{position}</span>
              <span className="text-gray-400 font-normal">of</span>
              <span>{total}</span>
            </div>

            {/* Next */}
            <button
              onClick={() => nextId && goTo(nextId, currentIndex + 1)}
              disabled={!nextId}
              className="flex items-center gap-2 px-5 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Next
              <SafeIcon icon={FiChevronRight} className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
